import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/bjs.styles.css";

export const BJS = () => {
	return <SubserviceWrapper config={services.bjs} />;
};
